import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { s3_url } from "common/constants";
import api from "common/api";
import { useAuth } from "authContext";
import LumenNavbar from "../../layout/LumenNavbar";
import NewFooter from "../../layout/NewFooter";
import "./NewLoginPage.css";

const NewLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      const response = await api.post(
        "/accounts/jwt/create/",
        { email, password },
        { skipRefreshToken: true },
      );
      login(response.data.access);
      localStorage.setItem("refreshToken", response.data.refresh);
      navigate("/dashboard");
    } catch (error: any) {
      setErr("Neispravni podaci za prijavu. Pokušajte ponovno.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LumenNavbar />
      <div className="new-login-page">
        <section className="nlp-hero">
          <Container className="nlp-hero-inner">
            <div className="nlp-hero-left">
              <img
                src={`${s3_url}/homepage/lumen-kauc.webp`}
                alt="Lumenko na kauču"
                className="nlp-hero-mascot"
                loading="lazy"
              />
            </div>
            <div className="nlp-hero-title">
              <span>LUMEN@HOME PRIJAVA</span>
            </div>
          </Container>
        </section>

        <Container className="nlp-content">
          <Row className="justify-content-center">
            <Col lg={8} xl={7}>
              <div className="nlp-card shadow">
                <h2 className="nlp-card-title text-center">
                  PRIJAVA U KORISNIČKI RAČUN
                </h2>

                <div className="nlp-intro mb-3">
                  <ul>
                    <li>
                      Ukoliko želite prijavu na pripreme državne mature možete
                      ispuniti{" "}
                      <Link to="/prijava-pripreme-drzavna-matura">
                        prijavnicu
                      </Link>
                    </li>
                    <li>
                      Za rezervaciju poduka možete slijedite poveznicu:{" "}
                      <Link to="/poduke/rezervacija">Rezervacija poduka</Link>
                    </li>
                  </ul>
                </div>

                {err && (
                  <Alert variant="danger" className="py-2">
                    {err}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="nlpEmail">
                    <Form.Label>Email adresa</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Unesite email adresu"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-2" controlId="nlpPassword">
                    <Form.Label>Lozinka</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Unesite lozinku"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <div className="text-start mb-2">
                    <Link to="/zaboravljena-lozinka" className="nlp-forgot">
                      Zaboravljena lozinka?
                    </Link>
                  </div>

                  <div className="text-center mt-4">
                    <Button
                      type="submit"
                      className="nlp-btn"
                      disabled={loading}
                    >
                      PRIJAVI ME
                    </Button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <NewFooter />
    </>
  );
};

export default NewLoginPage;
